import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import { ConnectionResource } from '../../Types';
import BrandingCard from './BrandingCard';
import DetailsCard from './DetailsCard';
import FinishConnectionCard from './FinishConnectionCard';
import GoodToKnow from './GoodToKnow';
import SpDetailsCard from './SpDetailsCard';

interface Props {
  resource: ConnectionResource;
}

const ConfigureIdp: React.FC<Props> = ({ resource }) => (
  <>
    <div className="rounded-lg border border-border bg-secondary p-4">
      <p className="font-semibold text-foreground">
        <T kind="Action needed: configure your identity provider with the values below" />
      </p>
      <p className="mt-1 text-sm text-muted-foreground">
        <T kind="Your ExecOnline connection is ready. Set up the application on your side, then paste your metadata URL to finish. These values do not expire - you can come back anytime." />
      </p>
    </div>
    <div className="mt-6 grid grid-cols-1 items-start gap-6 lg:grid-cols-5">
      <div className="flex flex-col gap-6 lg:col-span-3">
        <SpDetailsCard resource={resource} />
        <BrandingCard />
        <GoodToKnow />
      </div>
      <div className="flex flex-col gap-6 lg:col-span-2">
        <FinishConnectionCard resource={resource} />
        <DetailsCard resource={resource} />
      </div>
    </div>
  </>
);

export default observer(ConfigureIdp);
